import script from "./ObstaclesLayer.vue?vue&type=script&setup=true&lang=js"
export * from "./ObstaclesLayer.vue?vue&type=script&setup=true&lang=js"

import "./ObstaclesLayer.vue?vue&type=style&index=0&id=02fbb459&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02fbb459"]])

export default __exports__